// extracted by mini-css-extract-plugin
module.exports = {"root":"UserInfo_root__BAttC","text":"UserInfo_text__Fff7T"};